import React from "react";
import { Redirect } from "react-router-dom";
import Firebase from "./../firebase";
const firebase = new Firebase();

export default function SignOutPage() {
  firebase.auth.signOut();
  return <Redirect to={{ pathname: "/signin" }} />;
}
